

const article = `
## Solución

* Panel de control **>**

* Sistema y Seguridad **>**

* Opciones de Energía **>**

* Cambiar configuración del plan **>**

* Cambiar la configuración avanzada de energía **>** 

* Gráficos dinámicos intercambiables **>** 

* Configuración global:

> **Con batería**: Maximizar rendimiento
> **Con corriente alterna**: Maximizar rendimiento
`;

export default article;